import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Icon from 'components/commons/Icon';

import {
  ActionsList,
  ActionButton,
  ActionIconWrap,
  ActionLabel,
} from './styles';

const shareActions = [
  { id: 'telegram', icon: 'telegramIcon', label: 'telegram' },
  { id: 'viber', icon: 'viberIcon', label: 'viber' },
  { id: 'facebook', icon: 'facebookIcon', label: 'facebook' },
  { id: 'x', icon: 'xIcon', label: 'x' },
  { id: 'copy', icon: 'fileСopyIcon', label: 'copy' },
  { id: 'download', icon: 'downloadIcon', label: 'download' },
];

const CurrencyRateShareActions = ({ onAction, disabled, hasBlob }) => {
  const handleActionClick = actionId => {
    if (!disabled && onAction) {
      onAction(actionId);
    }
  };

  const visibleActions = hasBlob
    ? shareActions
    : shareActions.filter(({ id }) => id !== 'download');

  return (
    <ActionsList>
      {visibleActions.map(({ id, icon, label }) => (
        <ActionButton
          key={id}
          type="button"
          disabled={disabled}
          onClick={() => handleActionClick(id)}
        >
          <ActionIconWrap>
            <Icon name={icon} />
          </ActionIconWrap>
          <ActionLabel>
            <FormattedMessage id={label} />
          </ActionLabel>
        </ActionButton>
      ))}
    </ActionsList>
  );
};

CurrencyRateShareActions.propTypes = {
  onAction: PropTypes.func,
  disabled: PropTypes.bool,
  hasBlob: PropTypes.bool,
};

CurrencyRateShareActions.defaultProps = {
  onAction: null,
  disabled: false,
  hasBlob: false,
};

export default CurrencyRateShareActions;
